/**
 * Determines whether a queued play-log entry should be released to the visible log.
 *
 * An entry is released when:
 *   - forceFlush is true  (pitch_clock_start: previous pitch is definitively resolved)
 *   - entry has no resolution_id  (untagged entry, safe to show immediately)
 *   - revealedResolutionIds contains the entry's resolution_id
 *     (a phase component confirmed the result badge is on screen)
 *
 * An entry must NOT be released merely because its resolution_id is absent from the
 * current in-flight set (onlinePitchReveal / onlineFieldingResolution / onlineStealResolution).
 * That condition races: play_recorded can arrive before pitch_reveal populates the in-flight
 * set, making "not in flight" indistinguishable from "not yet started" — the log would
 * spoil the result before the animation shows it.
 */
export function shouldReleaseLogEntry(entry, revealedResolutionIds, forceFlush) {
  return (
    forceFlush
    || !entry.resolution_id
    || revealedResolutionIds.has(entry.resolution_id)
  );
}
